
import { CRUMB_LABEL_KEY, NAME } from './constants';
import List from './List.vue';

export const router = {
	path: NAME,
	name: NAME,
	component: List,
	CRUMB_LABEL_KEY,
};
